export const isOnServer = import.meta.env.SSR
